const API_CONFIG = {
  BASE_URL: 'https://api-sense.stepoutplay.com',
  ENDPOINTS: {
    STORE_MATCH_DATA: '/sense/store_on_field_match_data/'
  },
  HEADERS: {
    'accept': 'application/json, text/plain, */*',
    'accept-language': 'en-GB,en-US;q=0.9,en;q=0.8',
    'content-type': 'application/json'
  },
  AUTH: {
    ANALYST_TOKEN: 'ANALYST_TMS eyJhbGciOiJIUzI1NiIsInR5cCI6IkpXVCJ9.eyJ1c2VyX2lkIjoxNzAsIm9yZ2FuaXplcl9pZCI6MTE3LCJ1c2VybmFtZSI6MTcwLCJleHAiOjE3Njc3MzczMDUsImlhdCI6MTc2NzY5NDEwNX0.N2zG6K7f7z12k3mtDhKszy8gOfpGRn_WL9C7pABm9q0',
    ORGANIZER_TOKEN: 'ORGANIZER eyJhbGciOiJIUzI1NiIsInR5cCI6IkpXVCJ9.eyJ1c2VyX2lkIjo4NDEsInVzZXJuYW1lIjo4NDEsImV4cCI6MTkyNTEyMzQ3OSwiaWF0IjoxNzY5NjAzNDc5fQ.IqeX51ppqe2tFQO9xxq7iRiuROPdE7_7WVkajlMwXWQ'
  }
};

export default API_CONFIG;